import styled from "styled-components";
import { Button, Table } from "react-bootstrap";

export const CommentButtonWrapper = styled(Button)`
    & > div > svg {
        height: 14px;
        width: 14px;
        color: dimgray;
    }
`;

export const TableWrapper = styled(Table)`
    margin-bottom: 0px;

    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
    }

    & > tbody > tr > td.no-top-border {
        border-top: 0 none;
    }

    & > tbody > tr > td .editable-comments {
        padding: 5px;
        border-radius: 4px;
        border: 1px solid transparent;
    }

    & > tbody > tr > td .editable-comments:hover {
        border: 1px solid cornflowerblue;
    }
`;